/**
 * Safe asset loader — resolves images from attached_assets/ at build time
 * via import.meta.glob. Returns undefined for missing files instead of
 * throwing a build error. This lets the app build even when attached_assets/
 * is absent (it's gitignored and only exists on Replit).
 */

const generatedImages = import.meta.glob<{ default: string }>(
  "../../../attached_assets/generated_images/*.{png,webp,jpg,jpeg}",
  { eager: true },
);

const rootAssets = import.meta.glob<{ default: string }>(
  "../../../attached_assets/*.{png,webp,jpg,jpeg}",
  { eager: true },
);

const creatureImages = import.meta.glob<{ default: string }>(
  "../../../attached_assets/creatures/*.{png,webp,jpg,jpeg}",
  { eager: true },
);

function buildIndex(
  registry: Record<string, { default: string }>,
): Map<string, string> {
  const map = new Map<string, string>();
  for (const [path, mod] of Object.entries(registry)) {
    const filename = path.split("/").pop();
    if (filename) map.set(filename, mod.default);
  }
  return map;
}

const generatedIndex = buildIndex(generatedImages);
const rootIndex = buildIndex(rootAssets);
const creatureIndex = buildIndex(creatureImages);

export function getGeneratedImage(filename: string): string | undefined {
  return generatedIndex.get(filename);
}

export function getAsset(filename: string): string | undefined {
  return rootIndex.get(filename);
}

export function getCreatureImage(filename: string): string | undefined {
  return creatureIndex.get(filename);
}
